import { createSelector } from 'reselect';
import { setDefaultSource, getCountries } from '../../utils/helpers/costcenter';

import {
  getTotalReports,
  getCategoriedReports,
  getScheduledReports,
  getBusinessReportNameById
} from './helper';

import { getFilterCountries } from '../../utils/globalSelectors';

// Create select function to pick off the pieces of state we care about for this calculation
const getReportsCostCenterSelector = state =>
  state.common ? state.common.costcenter : {};

const getReportsCountrySelector = state =>
  state.common ? state.common.country : {};

const getReportsSelector = state => state.reports.reports;

// Local Country and cost center for edit report
const getReportsCostCenterSelectorLocal = state => state.reports.costcenter;

const getReportsCountrySelectorLocal = state => state.reports.country;

const getReportsCCAndCountryProps = (costcenter, country, countries) => {
  return setDefaultSource(country, costcenter, countries);
};

const getReportsCCAndCountryPropsLocal = (costcenter, country, countries) => {
  return setDefaultSource(country, costcenter, countries, false);
};

const getDynamicFilterData = state => state.common.dynamicFilters;

const getRestrictionFilterSelector = dynamicFilters => {
  let restrictions = [];

  if (dynamicFilters && dynamicFilters.length > 0) {
    dynamicFilters.forEach((item) => {
      if(item.value.length <= 0) return;

      restrictions.push({
        typeId: item.typeId,
        typeName: item.title,
        values: item.value.map((val) => val.value)
      })
    });
  }

  return {restrictions};
}

export const getReportsCCAndCountry = createSelector(
  getReportsCostCenterSelector,
  getReportsCountrySelector,
  getFilterCountries,
  getReportsCCAndCountryProps
);

export const getReportsCCAndCountryLocal = createSelector(
  getReportsCostCenterSelectorLocal,
  getReportsCountrySelectorLocal,
  getFilterCountries,
  getReportsCCAndCountryPropsLocal
);

export const getBusinessReports = createSelector(getReportsSelector, reports =>
  getCategoriedReports(reports, 'business')
);

export const getLegacyReports = createSelector(getReportsSelector, reports =>
  getCategoriedReports(reports, 'legacy')
);

const getRawUserReportsSelector = createSelector(getReportsSelector, reports =>
  getCategoriedReports(reports, 'user')
);

export const getUserReports = createSelector(
  getRawUserReportsSelector,
  getBusinessReports,
  (userReports, businessReports) =>
    userReports.map(report =>
      Object.assign({}, report, {
        businessReportName: getBusinessReportNameById(
          businessReports,
          report.businessReportId
        )
      })
    )
);

export const getTotalSchedulingReports = createSelector(
  getReportsSelector,
  getTotalReports
);

export const getRestrictionFilter = createSelector(
  getDynamicFilterData,
  getRestrictionFilterSelector
);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/selector.js